import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { submitSurveyAnswers, surveyQueryKeys } from '../api/surveys.api';
import type { SubmittedSurveyRef, SubmitSurveyPayload } from '../types/survey.types';

export function useSubmitSurveyAnswers(
  surveyId: number,
  onSuccess?: (submission: SubmittedSurveyRef) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SubmitSurveyPayload) => submitSurveyAnswers(surveyId, payload),
    onSuccess: (submission) => {
      void queryClient.invalidateQueries({ queryKey: surveyQueryKeys.detail(surveyId) });
      void queryClient.invalidateQueries({ queryKey: surveyQueryKeys.submissions(surveyId) });
      toast.success('Response submitted successfully');
      onSuccess?.(submission);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to submit response');
    },
  });
}
